export var tooltipPropSizes=["m","s","l"];export var tooltipPropSizesDefault=tooltipPropSizes[0];export var tooltipPropStatus=["normal","alert","success","warning"];
//# sourceMappingURL=types.js.map